import { html, KompisElement, property } from '@inter-ikea-kompis/web-component';
import type { ITheme } from '@inter-ikea-kompis/types';
import type { RenderResult } from '@inter-ikea-kompis/web-component';

import SheetFooterStyle from './SheetFooterStyle.js';

/**
 * SheetFooter component.
 */

export default class SheetFooter extends KompisElement {
	// Theme.
	@property({ type: Object, required: true })
	public theme!: ITheme;

	/**
	 * Renders the component.
	 *
	 * @returns Template.
	 */
	public override render(): RenderResult {
		return html`
			<style>
				${SheetFooterStyle.getStyle({
					theme: this.theme
				})}
			</style>
			<div class="container">
				<slot></slot>
			</div>
		`;
	}
}

declare global {
	interface HTMLElementTagNameMap {
		'kompis-sheet-footer': SheetFooter;
	}
}
